{
  "header": {
    "nameShowStaticText": false,
    "nameVariable": {
      "id": "c1caa14f-b6e8-4e19-bab4-cba0756a4b2e",
      "modelUri": "http://opcfoundation.org/UA/WireHarness/",
      "nodeId": "ns=1;i=6009",
      "displayName": "AssetId",
      "variablePath": "Identification.AssetId",
      "dataType": "String",
      "valueRank": -1,
      "modellingRule": "Mandatory",
      "hasProperties": false
    },
    "modelShowStaticText": false,
    "modelVariable": {
      "id": "9791c72c-a25f-47b9-a7fe-eb7e2330e06c",
      "modelUri": "http://opcfoundation.org/UA/WireHarness/",
      "nodeId": "ns=1;i=6045",
      "displayName": "Model",
      "variablePath": "Identification.Model",
      "dataType": "LocalizedText",
      "valueRank": -1,
      "modellingRule": "Optional",
      "hasProperties": false
    }
  },
  "imagesConfig": {
    "imageDefaults": {
      "[\\s\\S]*": "machine.jpg"
    }
  },
  "stacklight": {
    "colorVariable": {
      "id": "31f1ee6c-5079-42e4-9653-98b1bb5f8def",
      "modelUri": "http://opcfoundation.org/UA/WireHarness/",
      "nodeId": "ns=1;i=6015",
      "displayName": "CurrentState",
      "variablePath": "MachineryBuildingBlocks.MachineryItemState.CurrentState",
      "dataType": "LocalizedText",
      "valueRank": -1,
      "modellingRule": "Mandatory",
      "hasProperties": true
    },
    "colorValues": {
      "Executing": "#00FF00",
      "NotExecuting": "#FFFF00",
      "OutOfService": "#FF0000",
      "NotAvailable": "#0400ff"
    }
  },
  "timeline": {
    "variable": {
      "id": "31f1ee6c-5079-42e4-9653-98b1bb5f8def",
      "modelUri": "http://opcfoundation.org/UA/WireHarness/",
      "nodeId": "ns=1;i=6015",
      "displayName": "CurrentState",
      "variablePath": "MachineryBuildingBlocks.MachineryItemState.CurrentState",
      "dataType": "LocalizedText",
      "valueRank": -1,
      "modellingRule": "Mandatory",
      "hasProperties": true
    },
    "colorValues": {
      "Executing": "#00FF00",
      "NotExecuting": "#FFFF00",
      "NotAvailable": "#0400ff"
    }
  },
  "sections": [
    {
      "isPlaceholder": false,
      "title": "Identification",
      "rows": [
        {
          "isPlaceholder": false,
          "elements": [
            {
              "type": 0,
              "isPlaceholder": false,
              "label": "AssetId",
              "showAsLink": false,
              "valueVariable": {
                "id": "c1caa14f-b6e8-4e19-bab4-cba0756a4b2e",
                "modelUri": "http://opcfoundation.org/UA/WireHarness/",
                "nodeId": "ns=1;i=6009",
                "displayName": "AssetId",
                "variablePath": "Identification.AssetId",
                "dataType": "String",
                "valueRank": -1,
                "modellingRule": "Mandatory",
                "hasProperties": false
              }
            },
            {
              "type": 0,
              "isPlaceholder": false,
              "label": "Manufacturer",
              "showAsLink": false,
              "valueVariable": {
                "id": "e4fdec66-bc5e-435f-b005-f8176a0833b0",
                "modelUri": "http://opcfoundation.org/UA/WireHarness/",
                "nodeId": "ns=1;i=6010",
                "displayName": "Manufacturer",
                "variablePath": "Identification.Manufacturer",
                "dataType": "LocalizedText",
                "valueRank": -1,
                "modellingRule": "Mandatory",
                "hasProperties": false
              }
            },
            {
              "type": 0,
              "isPlaceholder": false,
              "label": "ProductInstanceUri",
              "showAsLink": true,
              "valueVariable": {
                "id": "869ef4b8-9f79-4e5b-8868-4e22645d2470",
                "modelUri": "http://opcfoundation.org/UA/WireHarness/",
                "nodeId": "ns=1;i=6012",
                "displayName": "ProductInstanceUri",
                "variablePath": "Identification.ProductInstanceUri",
                "dataType": "String",
                "valueRank": -1,
                "modellingRule": "Mandatory",
                "hasProperties": false
              }
            }
          ]
        },
        {
          "isPlaceholder": false,
          "elements": [
            {
              "type": 0,
              "isPlaceholder": false,
              "label": "Model",
              "showAsLink": false,
              "valueVariable": {
                "id": "9791c72c-a25f-47b9-a7fe-eb7e2330e06c",
                "modelUri": "http://opcfoundation.org/UA/WireHarness/",
                "nodeId": "ns=1;i=6045",
                "displayName": "Model",
                "variablePath": "Identification.Model",
                "dataType": "LocalizedText",
                "valueRank": -1,
                "modellingRule": "Optional",
                "hasProperties": false
              }
            },
            {
              "type": 0,
              "isPlaceholder": false,
              "label": "Location",
              "showAsLink": false,
              "valueVariable": {
                "id": "d7bea809-8b37-4cf6-8f99-eb055a6718bf",
                "modelUri": "http://opcfoundation.org/UA/WireHarness/",
                "nodeId": "ns=1;i=6037",
                "displayName": "Location",
                "variablePath": "Identification.Location",
                "dataType": "String",
                "valueRank": -1,
                "modellingRule": "Optional",
                "hasProperties": false
              }
            },
            {
              "type": 0,
              "isPlaceholder": false,
              "label": "Serial number",
              "showAsLink": false,
              "valueVariable": {
                "id": "361d6ea9-ed79-49eb-8251-d0027ba39ddf",
                "modelUri": "http://opcfoundation.org/UA/WireHarness/",
                "nodeId": "ns=1;i=6011",
                "displayName": "SerialNumber",
                "variablePath": "Identification.SerialNumber",
                "dataType": "String",
                "valueRank": -1,
                "modellingRule": "Mandatory",
                "hasProperties": false
              }
            }
          ]
        },
        {
          "isPlaceholder": false,
          "elements": [
            {
              "type": 0,
              "isPlaceholder": false,
              "label": "Device Class",
              "showAsLink": false,
              "valueVariable": {
                "id": "361d6ea9-ed79-49eb-8251-d0027ba39ddf",
                "modelUri": "http://opcfoundation.org/UA/WireHarness/",
                "nodeId": "ns=1;i=6011",
                "displayName": "SerialNumber",
                "variablePath": "Identification.DeviceClass",
                "dataType": "String",
                "valueRank": -1,
                "modellingRule": "Mandatory",
                "hasProperties": false
              }
            },
            {
              "type": 0,
              "isPlaceholder": false,
              "label": "Software Revision",
              "showAsLink": false,
              "valueVariable": {
                "id": "361d6ea9-ed79-49eb-8251-d0027ba39ddf",
                "modelUri": "http://opcfoundation.org/UA/WireHarness/",
                "nodeId": "ns=1;i=6011",
                "displayName": "SerialNumber",
                "variablePath": "Identification.SoftwareRevision",
                "dataType": "String",
                "valueRank": -1,
                "modellingRule": "Mandatory",
                "hasProperties": false
              }
            },
            {
              "type": 0,
              "isPlaceholder": false,
              "label": "Year of Construction",
              "showAsLink": false,
              "valueVariable": {
                "id": "361d6ea9-ed79-49eb-8251-d0027ba39ddf",
                "modelUri": "http://opcfoundation.org/UA/WireHarness/",
                "nodeId": "ns=1;i=6011",
                "displayName": "SerialNumber",
                "variablePath": "Identification.YearOfConstruction",
                "dataType": "String",
                "valueRank": -1,
                "modellingRule": "Mandatory",
                "hasProperties": false
              }
            }
          ]
        }
      ]
    },
    {
      "isPlaceholder": false,
      "title": "Machinery States",
      "rows": [
        {
          "isPlaceholder": false,
          "elements": [
            {
              "type": 2,
              "label": "Machinery Item State",
              "isPlaceholder": false,
              "badgeValues": [
                {
                  "backgroundColor": "#ff0000",
                  "textColor": "#000000",
                  "value": "NotAvailable",
                  "label": "Not Available"
                },
                {
                  "backgroundColor": "#804040",
                  "textColor": "#000000",
                  "value": "OutOfService",
                  "label": "Out Of Service"
                },
                {
                  "backgroundColor": "#00ff00",
                  "textColor": "#000000",
                  "value": "Executing"
                },
                {
                  "backgroundColor": "#ffff00",
                  "textColor": "#000000",
                  "value": "Not Executing"
                }
              ],
              "valueVariable": {
                "id": "897ce30a-1bbc-4051-9e76-f9809608f5cd",
                "modelUri": "http://VDMA.org/OPCUACS_demonstrator/",
                "nodeId": "ns=1;i=6091",
                "displayName": "CurrentState",
                "variablePath": "MachineryBuildingBlocks.MachineryItemState.CurrentState",
                "dataType": "LocalizedText",
                "valueRank": -1,
                "modellingRule": "Mandatory",
                "hasProperties": true
              }
            },
            {
              "type": 2,
              "label": "Machinery Operation Mode",
              "isPlaceholder": false,
              "badgeValues": [
                {
                  "backgroundColor": "#0000ff",
                  "textColor": "#000000",
                  "value": "None",
                  "label": "None"
                },
                {
                  "backgroundColor": "#fbff00",
                  "textColor": "#000000",
                  "value": "Maintenance",
                  "label": "Maintenance"
                },
                {
                  "backgroundColor": "##00ff00",
                  "textColor": "#000000",
                  "value": "Processing"
                },
                {
                  "backgroundColor": "#fbff00",
                  "textColor": "#000000",
                  "value": "Setup"
                }
              ],
              "valueVariable": {
                "id": "897ce30a-1bbc-4051-9e76-f9809608f5cd",
                "modelUri": "http://VDMA.org/OPCUACS_demonstrator/",
                "nodeId": "ns=1;i=6091",
                "displayName": "CurrentState",
                "variablePath": "MachineryBuildingBlocks.MachineryOperationMode.CurrentState",
                "dataType": "LocalizedText",
                "valueRank": -1,
                "modellingRule": "Mandatory",
                "hasProperties": true
              }
            }
          ]
        }
      ]
    },
    {
      "isPlaceholder": false,
      "title": "Job Management",
      "rows": [
        {
          "isPlaceholder": false,
          "elements": [
            {
              "type": 3,
              "isPlaceholder": false,
              "label": "",
              "columns": [
                {
                  "label": "JobOrderId",
                  "valueVariable": {
                    "id": "c59d494a-b3bc-40ec-aa67-c42f3fefcf83",
                    "modelUri": "http://opcfoundation.org/UA/Machinery/Result/",
                    "nodeId": "ns=0;i=31918",
                    "displayName": "JobOrderId",
                    "variablePath": "JobOrder.JobOrderID",
                    "dataType": "String",
                    "valueRank": -1,
                    "modellingRule": "Mandatory",
                    "hasProperties": false
                  }
                },
                {
                  "label": "Job State",
                  "valueVariable": {
                    "id": "d400c307-f639-426c-af22-b45ef5c2c07e",
                    "modelUri": "http://opcfoundation.org/UA/Machinery/Result/",
                    "nodeId": "ns=0;i=31918",
                    "displayName": "StateText",
                    "variablePath": "State[0].StateText",
                    "dataType": "LocalizedText",
                    "valueRank": -1,
                    "modellingRule": "Optional",
                    "hasProperties": false
                  }
                }
              ],
              "rowPlaceholderObject": "MachineryBuildingBlocks.JobManagement.JobOrderControl.JobOrderList.[PLACEHOLDER]"
            }
          ],
          "title": "Jobs"
        }
      ]
    },
    {
      "isPlaceholder": false,
      "title": "Monitoring",
      "rows": [
        {
          "isPlaceholder": false,
          "title": "Counters",
          "elements": [
            {
              "type": 0,
              "isPlaceholder": false,
              "label": "Power On Duration",
              "valueVariable": {
                "id": "0abde462-a3c2-4747-b3ce-74c5c74a4859",
                "modelUri": "http://opcfoundation.org/UA/MachineTool/",
                "nodeId": "ns=1;i=263",
                "displayName": "PowerOnDuration",
                "variablePath": "MachineryBuildingBlocks.OperationCounters.PowerOnDuration",
                "dataType": "Duration",
                "valueRank": -1,
                "modellingRule": "Mandatory",
                "hasProperties": false
              },
              "customUnit": "ms"
            },
            {
              "type": 0,
              "isPlaceholder": false,
              "label": "Operation Duration",
              "valueVariable": {
                "id": "57760161-0187-4c60-9af1-1e2752aa84d2",
                "modelUri": "http://opcfoundation.org/UA/MachineTool/",
                "nodeId": "ns=1;i=261",
                "displayName": "OperationDuration",
                "variablePath": "MachineryBuildingBlocks.OperationCounters.OperationDuration",
                "dataType": "Duration",
                "modellingRule": "Optional",
                "hasProperties": false
              },
              "customUnit": "ms"
            },
            {
              "type": 0,
              "isPlaceholder": false,
              "label": "Operation Cycle Counter",
              "valueVariable": {
                "id": "4d6933fd-2990-47d3-94f1-dad307b30fad",
                "modelUri": "http://opcfoundation.org/UA/MachineTool/",
                "nodeId": "ns=1;i=233",
                "displayName": "OperationCycleCounter",
                "variablePath": "MachineryBuildingBlocks.OperationCounters.OperationCycleCounter",
                "dataType": "UInt32",
                "modellingRule": "Optional",
                "hasProperties": false,
                "hasUnit": true,
                "hasRange": true
              }
            }
          ]
        }
      ]
    }
  ]
}
